import type { CoreApiUsers } from './core-api-users.types';
import type { CoreApi } from './core-api.http.types';

import http from './core-api.http';

const USER_READ_HEADERS = {
  'Cache-Control': 'no-cache',
};

export default {

  async createUser(data: CoreApiUsers.CreateUserRequest) {
    const res = await http.post<CoreApiUsers.UserResponse>('/backoffice/usuarios', data);
    return res.data.data;
  },

  async getUser(id: number) {
    const res = await http.get<CoreApiUsers.UserResponse>(
      `/backoffice/usuarios/${id}`,
      { headers: USER_READ_HEADERS },
    );
    return res.data.data;
  },

  async inactivateUser(data: CoreApiUsers.InactivateUserRequest) {
    const res = await http.post<CoreApiUsers.UserResponse>('/usuarios/status', data);
    return res.data.data;
  },

  async me() {
    const res = await http.get<CoreApi.MeResponse>('/usuarios/me');
    return res.data.data;
  },

  async parceiros(params?: CoreApi.GetPartnerRequest) {
    const url = new URLSearchParams();
    if (params?.page) url.append('page', params.page.toString());
    if (params?.search_term) url.append('search_term', params.search_term);

    const res = await http.get<CoreApi.GetPartnerResponse>(`/v1/parceiros${url.toString() !== '' ? `?${url}` : ''}`);
    return res.data;
  },

  async updateUser(id: number, data: CoreApiUsers.UpdateUserRequest) {
    const res = await http.put<CoreApiUsers.UserResponse>(`/backoffice/usuarios/${id}`, data);
    return res.data.data;
  },
};
